const APP_FONT_FAMILY = getComputedStyle(document.documentElement).getPropertyValue('--lp-font-family-base');

// Resolve the CSS variable up front. On hover, ECharts re-renders the line for tooltips and symbols.
// If the color is fetched during that render, it can fail to resolve.
const COLOR = getComputedStyle(document.documentElement).getPropertyValue('--lp-color-data-info');

const defaultColors = {
  color: COLOR,
  axis: 'var(--lp-color-text-ui-secondary)',
  markLine: 'var(--lp-color-text-ui-secondary)',
  symbolBorder: 'var(--lp-color-fill-interactive-primary)', // Should be light in dark mode
  splitLine: 'var(--lp-color-border-field-base)',
  tooltipLine: 'var(--lp-color-data-comparison)',
  tooltipText: 'var(--lp-color-text-ui-primary-base)',
  backgroundColor: 'var(--lp-color-bg-ui-primary)',
};

const baseAxisOptions = {
  axisLine: {
    show: false,
    lineStyle: {
      color: defaultColors.axis,
    },
  },
  axisTick: {
    show: false,
    lineStyle: {
      color: defaultColors.axis,
    },
  },
  axisLabel: {
    show: true, // default: show labels
    color: defaultColors.axis,
    hideOverlap: true,
    fontSize: 10,
  },
  splitLine: {
    show: false,
    lineStyle: {
      color: [defaultColors.splitLine],
      type: 'dashed',
    },
  },
};

export const defaultChartTheme = {
  color: defaultColors.color,
  textStyle: {
    fontFamily: APP_FONT_FAMILY,
    fontSize: 10,
  },
  backgroundColor: defaultColors.backgroundColor,
  valueAxis: {
    ...baseAxisOptions,
    splitLine: {
      ...baseAxisOptions.splitLine,
      show: true, // Show horizontal lines
    },
  },

  timeAxis: {
    ...baseAxisOptions,
    axisLine: {
      ...baseAxisOptions.axisLine,
      show: true, // Show bottom axis line
    },
  },
  tooltip: {
    trigger: 'axis',
    triggerOn: 'mousemove|click',
    backgroundColor: defaultColors.backgroundColor,
    borderColor: defaultColors.splitLine,
    borderWidth: 1,
    textStyle: {
      color: defaultColors.tooltipText,
    },
    axisPointer: {
      lineStyle: {
        color: defaultColors.tooltipLine,
        width: 1,
        type: 'solid',
      },
    },
  },
  markLine: {
    symbol: 'none',
    silent: true,
    label: {
      show: false,
      position: 'insideEndTop',
      color: defaultColors.markLine,
      fontSize: 10,
    },
    lineStyle: {
      type: 'dashed',
      width: 1,
      color: defaultColors.markLine,
    },
  },

  // Chart type styles
  line: {
    itemStyle: {
      borderWidth: '1',
      color: defaultColors.color,
      borderColor: defaultColors.symbolBorder,
    },
    symbolSize: 6,
    showSymbol: true,
    symbol: 'circle',
    smooth: true,
  },
  bar: {
    itemStyle: {
      barBorderWidth: '0',
    },
    barWidth: '80%',
    barGap: '0%',
  },
};
